import { makeStyles } from "@mui/styles";
import { createTheme } from "@mui/material/styles";

const theme = createTheme();

const useHeaderStyles = makeStyles(() => ({
    headerContainer: {
        width: "100%",
    },
    topBlueBar: {
        background: "#38aae9",
    },
    toolbarCenter: {
        justifyContent: "center",
    },
    clientLogoText: {
        fontWeight: "bold",
        "@media (max-width:600px)": {
            fontSize: "1rem",
        },
        "@media (min-width:601px)": {
            fontSize: "1.5rem",
        },
    },
    blackBar: {
        backgroundColor: "black",
        color: "yellow",
        display: "flex",
        justifyContent: "space-between",
        alignItems: "center",
        paddingLeft: "16px",
        paddingRight: "16px",
        flexWrap: "wrap",
        minHeight: "40px",
        "@media (max-width:599px)": {
            minHeight: "26px",
        },
    },
    blackBarContainer: {
        backgroundColor: "black",
        color: "yellow",
        display: "flex",
        justifyContent: "space-between",
        alignItems: "center",
        paddingLeft: "6px",
        paddingRight: "8px",
        paddingTop: "6px",
        paddingBottom: "6px",
        flexWrap: "nowrap",
        gap: "6px",
        width: "100%",
        "@media (max-width:599px)": {
            paddingTop: "1px",
            paddingBottom: "1px",
            gap: "4px",
            paddingRight: "0px",
        },
    },
    examTitle: {
        fontWeight: "bold",
        [theme.breakpoints.down("md")]: {
            fontSize: "0.68rem !important",
            width: "100%",
            textAlign: "center",
            paddingTop: "4px",
        },
    },
    iconsContainer: {
        display: "flex",
        alignItems: "center",
        gap: "12px",
        color: "white",
        paddingRight: "4px",
        flexShrink: 0,
        [theme.breakpoints.down("md")]: {
            gap: "2px", // reduced gap as we use space-between
            paddingRight: "0px",
            width: "100%",
            justifyContent: "space-between",
        },
    },
    iconTextGroup: {
        display: "flex",
        alignItems: "center",
        gap: "4px",
        "&:hover": {
            textDecoration: "underline",
        },

    },
    instructionsIcon: {
        color: "white",
        cursor: "pointer",
        "& .MuiTypography-body2": {
            "@media (max-width:599px)": {
               fontSize: "0.68rem !important",
            },
        },
    },
    questionpaperIcon: {
        color: "lightgreen",
    },
    instructionsDialogContent: {
        whiteSpace: "pre-line",
        "& img": {
            width: "100% !important",
            height: "auto !important",
            maxWidth: "100% !important",
            display: "block",
            margin: "10px 0",
        },
    },
    mobileMarginTop: {
        "@media (max-width:600px)": {
            marginTop: "8px",
        },
    },
}));

export default useHeaderStyles;